/* eslint-disable react/prop-types */
import React from 'react';

import { Typography } from '@material-ui/core';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';

import TiktokIcon from '../../../assets/icons/tiktokicon.png';
import {
  CustomLink,
  FooterContainer,
  SocialMediaIconsContainer,
  LinksContainer,
  TermsAndConditionsContainer,
} from './styles';

function formatUrl(url) {
  var httpString = 'http://',
    httpsString = 'https://';
  if (
    url.substr(0, httpString.length) !== httpString &&
    url.substr(0, httpsString.length) !== httpsString
  )
    url = httpString + url;
  return url;
}

export default function Footer({
  instaAccount,
  fbAccount,
  linkedinAccount,
  tiktokAccount,
  contactEmail,
  link1Title,
  link1Url,
  link2Title,
  link2Url,
  color,
  fontColor,
}) {
  const iconsAndFontColor = fontColor || '#ffffff';
  return (
    <FooterContainer square elevation={0} color={color}>
      <SocialMediaIconsContainer>
        {instaAccount && (
          <CustomLink
            href={`https://www.instagram.com/${instaAccount}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <InstagramIcon
              sx={{ padding: '0 10px', color: iconsAndFontColor }}
              fontSize="small"
            />
          </CustomLink>
        )}
        {fbAccount && (
          <CustomLink
            href={`https://www.facebook.com/${fbAccount}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FacebookIcon
              sx={{ padding: '0 10px', color: iconsAndFontColor }}
              fontSize="small"
            />
          </CustomLink>
        )}
        {linkedinAccount && (
          <CustomLink
            href={`https://www.linkedin.com/${linkedinAccount}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <LinkedInIcon
              sx={{ padding: '0 10px', color: iconsAndFontColor }}
              fontSize="small"
            />
          </CustomLink>
        )}
        {tiktokAccount && (
          <CustomLink
            href={`https://www.tiktok.com/${tiktokAccount}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              alt="tiktokicon"
              src={TiktokIcon}
              style={{
                padding: '0 10px',
                width: 15,
                height: 15,
                color: iconsAndFontColor,
              }}
            />
          </CustomLink>
        )}
        {(() => {
          if (contactEmail) {
            if (contactEmail.includes('@')) {
              return (
                <CustomLink
                  href={`mailto:${contactEmail}?subject=Contato%20via%20CliqueTroque`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <EmailIcon
                    sx={{ padding: '0 10px', color: iconsAndFontColor }}
                    fontSize="small"
                  />
                </CustomLink>
              );
            } else {
              return (
                <CustomLink
                  href={formatUrl(contactEmail)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <SupportAgentIcon
                    sx={{ padding: '0 10px', color: iconsAndFontColor }}
                    fontSize="small"
                  />
                </CustomLink>
              );
            }
          }
        })()}
      </SocialMediaIconsContainer>
      <TermsAndConditionsContainer>
        {link1Url && (
          <CustomLink
            href={formatUrl(link1Url)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Typography style={{ fontSize: 12, color: iconsAndFontColor }}>
              {link1Title || 'Link 1'}
            </Typography>
          </CustomLink>
        )}
        {link2Url && (
          <CustomLink
            href={formatUrl(link2Url)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Typography
              style={{
                fontSize: 12,
                paddingLeft: '10px',
                color: iconsAndFontColor,
              }}
            >
              {link2Title || 'Link 2'}
            </Typography>
          </CustomLink>
        )}
      </TermsAndConditionsContainer>
      <LinksContainer>
        <CustomLink
          href="https://www.cliqueretire.com.br/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Typography
            style={{
              fontSize: 12,
              paddingLeft: '10px',
              color: iconsAndFontColor,
            }}
          >
            Powered by CliqueRetire
          </Typography>
        </CustomLink>
      </LinksContainer>
    </FooterContainer>
  );
}
